import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Button } from '../Button';
import { EditableContentRowFormWrapper } from './editable-content-row-form-wrapper.component';

type EditableContentRowClasses = 'root' | 'content' | 'editButtonContainer';

export type EditableContentRowProps = {
  editMode: boolean;
  onSetEditMode: (editMode: boolean) => void;
  content: React.ReactNode;
  editContent: React.ReactNode;
  classes?: {
    [key in EditableContentRowClasses]?: string;
  };
};

export const EditableContentRow: React.FC<EditableContentRowProps> = ({ editMode = false, ...props }) => {
  const { classes, cx } = useStyles();

  const editContent = (
    <EditableContentRowFormWrapper onCancel={() => props.onSetEditMode(false)}>
      {props.editContent}
    </EditableContentRowFormWrapper>
  );

  return (
    <Box role="row" className={cx([ classes.root, props.classes?.root ])}>
      <Box flex={1}>
        {editMode ? editContent : props.content}
      </Box>
      {!editMode && (
        <Box display="flex" justifyContent="flex-end" alignItems="center" maxWidth="216px" width="100%" ml={2}>
          <Button
            color="secondary"
            onClick={() => props.onSetEditMode(true)}
          >
            Edit
          </Button>
        </Box>
      )}
    </Box>
  );
};

const useStyles = makeStyles()((theme) => ({
  root: {
    padding: theme.spacing(2, 2, 2, 3),
    display: 'flex',
  }
}));
